import api from '../index'
import { CACHE_TAG_WORK_ORDER_FEE_TAX_LINE_VERSION_LIST } from '../cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    createUpdateDraftFee: builder.mutation({
      query: body => {
        return { url: '/api/v1/core/work-orders/fee', method: 'POST', body }
      },
      invalidatesTags: [CACHE_TAG_WORK_ORDER_FEE_TAX_LINE_VERSION_LIST],
    }),
  }),
})

export const { useCreateUpdateDraftFeeMutation } = extendedApi
